import styles from "./CustomerInfoExpander.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ChevronRight } from "react-ikonate";
import { Expander } from "shared/components/Expander/Expander";

/**
 * Styled expander for Customer Info sections.
 */
export function CustomerInfoExpander({
  icon,
  title,
  color,
  isOpen,
  onToggle,
  children,
}) {
  return (
    <Expander
      isOpen={isOpen}
      onToggle={onToggle}
      renderHeader={(open) => (
        <div className={styles.header}>
          <div className={styles.iconZone} style={{ backgroundColor: color }}>
            {icon}
          </div>
          <div className={styles.titleZone} style={{ backgroundColor: color }}>
            <h2>{title}</h2>

            <ChevronRight
              className={classNames(styles.caretIcon, {
                [styles.active]: open,
              })}
              width={34}
              height={34}
            />
          </div>
        </div>
      )}
    >
      <div className={styles.content}>{children}</div>
    </Expander>
  );
}

CustomerInfoExpander.propTypes = {
  /**
   * A JSX fragment containing the section icon.
   */
  icon: PropTypes.element,

  /**
   * Title text.
   */
  title: PropTypes.string.isRequired,

  /**
   * CSS color for the header background.
   */
  color: PropTypes.string.isRequired,

  /**
   * Boolean to set open/closed visual state.
   */
  isOpen: PropTypes.bool,
};
